import {Injectable} from '@angular/core';
import {ConnectService} from "./connect.service";

@Injectable({
    providedIn: 'root'
})
export class WebPushService {
  logo : string;

  constructor(private connectService: ConnectService) {
    this.logo = this.connectService.getLogo();
  }
  requestPermission(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      Notification.requestPermission().then(function (result) {
        if (result === 'granted') {
          resolve();
        } else {
          reject('We weren\'t granted permission.');
        }
      }).catch(reject);
    });
  }

    showNotification(title: string, options?: NotificationOptions): void {
      options.icon = this.logo;
        if (!("Notification" in window)) {
            console.log("This browser does not support notifications.");
        } else if (Notification.permission === "granted") {
            new Notification(title, options);
        }
    }
}
